<template>
  <b-modal
    title="Add user to organization"
    v-model="showModal"
    @ok.prevent="submit(false)"
    :ok-disabled="sending"
    @cancel.prevent="cancel"
    @hidden="cancel"
  >
    <b-form>
      <b-form-group label="Name"
        label-for="user-name"
        invalid-feedback="Please enter a name"
        :state="errors.length == 0 ? null : form.name !== ''">
        <b-form-input
          id="user-name"
          v-model.trim="form.name"
          required
          autofocus
          maxlength="100"
          :state="errors.length == 0 ? null : form.name !== ''">
        </b-form-input>
      </b-form-group>
      <b-form-group label="Email"
        label-for="user-email"
        invalid-feedback="Please enter an email"
        :state="errors.length == 0 ? null : validEmail(form.email)">
        <b-form-input
          id="user-email"
          v-model.trim="form.email"
          required
          maxlength="254"
          :state="errors.length == 0 ? null : validEmail(form.email)">
        </b-form-input>
      </b-form-group>
    </b-form>
    <BaseMessageBlock :messages="errors"></BaseMessageBlock>
    <template v-slot:modal-ok >
      <div style="width: 36px;" >
        <b-spinner v-if="sending" small label="Spinning"/>
        <div v-else>Add</div>
      </div>
    </template>
    <ConfirmExistingUserModal
      ref="confirm-existing-user-modal"
      :user="existingUser"
      @confirm="confirmUserSubmit"
      @cancel="confirmUserCancel">
    </ConfirmExistingUserModal>
  </b-modal>
</template>

<script>
import axios from 'axios';
import ConfirmExistingUserModal from "@/modal-components/ConfirmExistingUserModal.vue";

export default {
  props: {
    organizationId: { type: String, default: "" },
    users: { type: Array, default: () => [] }
  },
  components: {
    ConfirmExistingUserModal
  },
  data() {
    return {
      errors: [],
      showModal: false,
      sending: false,
      form: this.newForm(),
      existingUser: this.newExistingUser()
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    cancel() {
      this.resetForm();
      this.hide();
    },
    submit(force) {
      this.addUserRelation(force);
    },
    resetForm() {
      this.errors = [],
      this.form = this.newForm();
    },
    addUserRelation(force){
      this.errors = [];

      if (!this.validateUser(this.form)) {
        return;
      }

      let request = {
        user: {
          userId: this.form.userId,
          name: this.form.name,
          email: this.form.email
        },
        relation: {
          userId: this.form.userId,
          tableId: this.organizationId,
          tableName: "Organizations",
          permissionLevel: this.form.permissionLevel
        }
      };

      let url = `${this.$api_url}/organizations/${this.organizationId}/users/add`;
      if (force) {
        url += "?force=true";
      }

      this.sending = true;
      axios
        .post(url, request, this.getReqConfig())
        .then(() => {
          this.$emit('submit');
          this.resetForm();
          this.hide();
        })
        .catch(err => {
          if (err.response.status === 409) {
            this.confirmUser(err.response.data);
          } else {
            this.errors.push(...this.$helpers.formatErrors(err));
          }
        })
        .finally(() => {
          this.sending = false;
        });
    },
    validateUser(form){
      const initErrors = this.errors.length;

      if (!form.name) {
        this.errors.push({ message: 'Name cannot be empty'})
      }

      if (!form.email.length) {
        this.errors.push({message: 'Email cannot be empty' })
      } else if (!this.validEmail(form.email)){
        this.errors.push({ message: 'Email must be valid' });
      }

      return initErrors === this.errors.length;
    },
    validEmail(email){
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    confirmUser(user) {
      this.form.userId = user.userId;
      this.existingUser.name = user.name;
      this.existingUser.email = user.email;
      this.existingUser.phone = user.phone;
      this.$refs['confirm-existing-user-modal'].show();
    },
    confirmUserSubmit() {
      this.submit(true);
    },
    confirmUserCancel() {
      this.newExistingUser();
    },
    newForm() {
      return  {
        userId: this.$helpers.generateUUID(),
        name: '',
        email: '',
        permissionLevel: 'Sponsor'
      };
    },
    newExistingUser() {
      return {
        name: "",
        email: '',
        phone: ''
      };
    }
  },
  computed: {

  }
}
</script>

